import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import Utilidades from '@/shared/config/utilidades';
import ResumenPagosComponet from '@/entities/seguimiento/finiquito/resumen-pagos/resumen-pagos.vue';
import PagoService from '@/entities/seguimiento/financiero/pago.service';
import { IPago } from '@/shared/model/seguimiento/financiero/pago.model';
import AlertService from '@/shared/alert/alert.service';
import * as mesUtils from '@/shared/date/mes-utils';
import * as dateUtils from '@/shared/date/date-utils';
import { EstadoPago } from '@/shared/model/enumerations/estado-pago';
import { BvTableFieldArray } from 'bootstrap-vue';

interface IPagoTabla extends IPago {
  montoRechazo: number;
  mes: string;
  anio: number;
}
@Component({
  components: {
    'resumen-pagos-table': ResumenPagosComponet,
  },
})
export default class FiniquitoComponeNt extends Vue {
  @Inject('pagoService') private readonly pagoService: () => PagoService;
  @Inject('alertService') private readonly alertService: () => AlertService;

  @Prop({ required: true })
  public idBeca: string;

  @Prop({ required: true })
  public visible: boolean;

  public readonly campos: BvTableFieldArray = [
    {
      key: 'inicioPago',
      label: this.$t('apeironGwApp.finiquito.tabla.fechaPago').toString(),
      class: 'font-weight-bold',
      formatter: dateUtils.defaultFormat,
    },
    {
      key: 'mes',
      label: this.$t('apeironGwApp.finiquito.tabla.mes').toString(),
    },
    {
      key: 'anio',
      label: this.$t('apeironGwApp.finiquito.tabla.anio').toString(),
    },
    {
      key: 'montoPago',
      label: this.$t('apeironGwApp.finiquito.tabla.apoyoEconomico').toString(),
      class: 'text-right',
      formatter: (value: number) => this.utilidades.formatearMonto(value),
    },
    {
      key: 'monedaApoyo',
      label: this.$t('apeironGwApp.finiquito.tabla.monedaApoyo').toString(),
      class: 'text-center',
      formatter: () => 'PESO',
    },
    {
      key: 'montoRechazo',
      label: this.$t('apeironGwApp.finiquito.tabla.rechazoBancario').toString(),
      class: 'text-right',
      formatter: (value: number) => this.utilidades.formatearMonto(value),
    },
  ];

  public utilidades = new Utilidades();
  public isSearching = false;
  public perPageOptions = [10, 50, 100, 150];
  public pagos: Array<IPagoTabla> = [];
  public currentPage = 1;
  public perPage = 10;
  public totalRows = 0;
  public propOrder = 'inicioPago';
  public reverse = false;
  public componenteVisible = false;

  public mounted(): void {
    this.componenteVisible = this.visible;
    this.retrievePagos();
  }

  public retrievePagos(): void {
    this.isSearching = true;
    this.pagos = [];
    const paginationQuery = {
      page: this.currentPage - 1,
      size: this.perPage,
      sort: this.sort(),
    };

    this.pagoService()
      .retrieveByBeca(this.idBeca, [EstadoPago.PAGADO, EstadoPago.RECHAZADO], paginationQuery)
      .then(result => {
        if (result?.data?.length > 0) {
          for (const pago of result.data) {
            const partes = pago.inicioPago.toString().split('-');
            const pagoNuevo = {
              ...pago,
              montoRechazo: pago.estadoActual === EstadoPago.RECHAZADO ? pago.montoPago : 0,
              mes: mesUtils.obtenerNombreMes(parseInt(partes[1])),
              anio: parseInt(partes[0]),
            };
            this.pagos.push(pagoNuevo);
          }
          this.totalRows = Number(result.headers['x-total-count']);
        }
      })
      .catch(error => {
        if (error?.response?.status !== 404) {
          this.alertService().showHttpError(this, error.response);
        }
      })
      .finally(() => {
        this.isSearching = false;
      });
  }

  public handlePageChange(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.retrievePagos();
  }

  public handlePageSizeChange(): void {
    this.resetPagination();
    this.retrievePagos();
  }

  private resetPagination(): void {
    this.currentPage = 1;
    this.totalRows = 0;
  }

  public sort(): Array<any> {
    const result = [this.propOrder + ',' + (this.reverse ? 'desc' : 'asc')];
    if (this.propOrder !== 'id') {
      result.push('id');
    }
    return result;
  }
}
